import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ children, to, variant = 'primary', className = '', ...props }) => {
  const baseStyles = "inline-flex items-center justify-center px-8 py-3 text-sm font-medium transition-all duration-300 rounded-sm tracking-wide";
  
  const variants = {
    primary: "bg-veloura-accent text-white hover:bg-veloura-text shadow-md hover:shadow-lg",
    secondary: "bg-veloura-primary text-veloura-text hover:bg-veloura-secondary",
    outline: "border border-veloura-accent text-veloura-accent hover:bg-veloura-accent hover:text-white"
  };

  const classes = `${baseStyles} ${variants[variant]} ${className}`;

  if (to) {
    return <Link to={to} className={classes} {...props}>{children}</Link>;
  }

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
};

export default Button;